module.exports = __webpack_public_path__ + "static/media/tourA.13d6efce.png";